/* src/app/components/notification-location-data-stale-toast/notification-location-data-stale-toast.component.scss */
:host {
  position: sticky;
  top: 0;
  z-index: 10000;
  width: 100%;
}
:host .notification-location-data-stale-toast {
  background-color: #FFD100;
  height: 42px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}
:host .notification-location-data-stale-toast .message {
  font-weight: 700;
  font-size: 14px;
  color: #212121;
}
/*# sourceMappingURL=notification-location-data-stale-toast.component.css.map */
